import { gql } from "@/services/httpAdapter.ts";
import { CitExportHistoryFragment } from "./fragments.ts";

export const onUpdateCit = gql`
	subscription onUpdateCit($locationId: String, $commissionCycleId: String, $payPeriodId: String) {
		onUpdateCit(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			_id
			locationId
			commissionCycleId
			payPeriodId
			exportHistory {
				...CitExportHistory
			}
			analytics {
				age
				quantity
				amount
			}
			lastModifiedOn
		}
	}
	${CitExportHistoryFragment}
`;

export const onUpdateCitActivities = gql`
	subscription onUpdateCitActivities($locationId: String, $commissionCycleId: String, $payPeriodId: String) {
		onUpdateCitActivities(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
		}
	}
`;

export const onExportCitActivities = gql`
	subscription onExportCitActivities($locationId: String, $commissionCycleId: String, $payPeriodId: String) {
		onExportCitActivities(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
			urlDetails {
				error {
					message
					status
				}
			}
			journalDetails {
				message
				success
			}
		}
	}
`;

export interface IUpdateCitActivitiesSubscriptionResponse {
	data: {
		onUpdateCitActivities: {
			locationId: string;
			commissionCycleId: string;
			payPeriodId: string;
		};
	};
}

export interface IExportCitActivitiesSubscriptionResponse {
	data: {
		onExportCitActivities: {
			locationId: string;
			commissionCycleId: string;
			payPeriodId: string;
			urlDetails?: {
				error?: {
					message: string;
					status: string;
				};
			};
			journalDetails?: {
				message: string;
				success: boolean;
			};
		};
	};
}
